import { SVGProps } from 'react'
import { chakra } from '@chakra-ui/react'

export const ThankYouSvgr = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    width={283}
    height={165}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.075 12.18C1.075 6.005 6.08 1 12.255 1h258.782c6.175 0 11.18 5.005 11.18 11.18V165H1.075V12.18Z"
      fill="#FBFCFD"
    />
    <path
      d="M272.069 1.094H12.112A10.963 10.963 0 0 0 1.25 12.157v6.883h281.675v-6.883c.056-6.053-4.804-11.005-10.856-11.063Z"
      fill="#000"
    />
    <ellipse cx={15.96} cy={10.073} rx={1.733} ry={1.765} fill="#fff" />
    <ellipse cx={26.654} cy={10.073} rx={1.733} ry={1.765} fill="#fff" />
    <ellipse cx={37.354} cy={10.073} rx={1.733} ry={1.765} fill="#fff" />
    <path d="M1.256 19.058h281.669v4.462H1.255v-4.462Z" fill="#C9CCCF" />
    <rect
      x={45.769}
      y={109.338}
      width={67.474}
      height={192.825}
      rx={4.51}
      transform="rotate(-90 45.77 109.338)"
      fill="#E4E7F6"
    />
    <rect
      x={45.769}
      y={129.77}
      width={9.577}
      height={192.825}
      rx={4.51}
      transform="rotate(-90 45.769 129.77)"
      fill="#E4E7F6"
    />
    <rect
      x={45.769}
      y={150.201}
      width={9.577}
      height={192.825}
      rx={4.51}
      transform="rotate(-90 45.77 150.201)"
      fill="#E4E7F6"
    />
    <circle
      cx={142.338}
      cy={75.727}
      r={18.498}
      fill="#05CC9A"
      stroke="#000"
      strokeWidth={0.638}
    />
    <path
      transform="rotate(42.529 -31.564 208.703) skewX(.036)"
      stroke="#000"
      strokeWidth={0.638}
      d="M0-.319h8.672"
    />
    <path
      transform="rotate(-45.018 168.639 -126.858)"
      stroke="#000"
      strokeWidth={0.638}
      d="M0-.319h18.082"
    />
    <path
      d="M282.217 165V12.18c0-6.175-5.005-11.18-11.18-11.18H12.255C6.08 1 1.075 6.005 1.075 12.18V165"
      stroke="#000"
      strokeWidth={0.638}
    />
  </svg>
))
